export enum GUESTAPP_NAVIGATION_MODE {
  property_name = 'PROPERTY_NAME',
  logo = 'LOGO',
  property_name_and_logo = 'PROPERTY_NAME_AND_LOGO',
}

export enum BUTTONS_STYLES_OPTIONS {
  round = 'ROUND',
  square = 'SQUARE',
}
